// extracted by mini-css-extract-plugin
export default {"root":"PrepAccordionMenu_root__L0Rp+"};